import { makeStyles } from "@material-ui/core/styles";

export const useTextStyles = makeStyles({
  paragraph: {
    marginTop: 5,
    marginBottom: 5,
  },
});
